import i18n from './index';
import { NormalizedApiError, normalizeAxiosError } from '@api/errors';

/**
 * UI-facing resolver: turn any thrown error into a Turkish message via the
 * `errors` namespace, keyed by the BE error `code` (the FE/BE contract).
 *
 * Resolution order:
 *   1. `errors:<code>`        — known business/base code (e.g. SLUG_CONFLICT)
 *   2. `errors:HTTP_<status>` — per-status fallback (e.g. HTTP_404)
 *   3. `errors:default`       — generic fallback
 *
 * The raw BE message (often English) is never shown to the user; it stays on
 * `NormalizedApiError.message` for logging only.
 */
export function resolveApiErrorMessage(err: unknown): string {
  const normalized = err instanceof NormalizedApiError ? err : normalizeAxiosError(err);

  // Keys are resolved dynamically from the BE code, so bypass the literal-key
  // typing (the values are guaranteed present in errors.json / checked via exists).
  const t = i18n.t.bind(i18n) as (key: string) => string;

  const codeKey = `errors:${normalized.code}`;
  if (i18n.exists(codeKey)) return t(codeKey);

  const statusKey = `errors:HTTP_${normalized.status}`;
  if (i18n.exists(statusKey)) return t(statusKey);

  return t('errors:default');
}
